/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoTokenStatisticsTokenData model module.
 * @module model/PerplayStatisticsControllerDtoTokenStatisticsTokenData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoTokenStatisticsTokenData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoTokenStatisticsTokenData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoTokenStatisticsTokenData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoTokenStatisticsTokenData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenData} The populated <code>PerplayStatisticsControllerDtoTokenStatisticsTokenData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoTokenStatisticsTokenData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('userWalletBalanceHvh')) {
                obj['userWalletBalanceHvh'] = ApiClient.convertToType(data['userWalletBalanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('userWalletBalancePer')) {
                obj['userWalletBalancePer'] = ApiClient.convertToType(data['userWalletBalancePer'], 'Number');
            }
            if (data.hasOwnProperty('userWalletBalanceXper')) {
                obj['userWalletBalanceXper'] = ApiClient.convertToType(data['userWalletBalanceXper'], 'Number');
            }
            if (data.hasOwnProperty('userWalletBalanceUsdt')) {
                obj['userWalletBalanceUsdt'] = ApiClient.convertToType(data['userWalletBalanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('userWalletBalanceArb')) {
                obj['userWalletBalanceArb'] = ApiClient.convertToType(data['userWalletBalanceArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoTokenStatisticsTokenData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoTokenStatisticsTokenData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['targetDate'] = undefined;

/**
 * @member {Number} userWalletBalanceHvh
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['userWalletBalanceHvh'] = undefined;

/**
 * @member {Number} userWalletBalancePer
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['userWalletBalancePer'] = undefined;

/**
 * @member {Number} userWalletBalanceXper
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['userWalletBalanceXper'] = undefined;

/**
 * @member {Number} userWalletBalanceUsdt
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['userWalletBalanceUsdt'] = undefined;

/**
 * @member {Number} userWalletBalanceArb
 */
PerplayStatisticsControllerDtoTokenStatisticsTokenData.prototype['userWalletBalanceArb'] = undefined;






export default PerplayStatisticsControllerDtoTokenStatisticsTokenData;

